// Variables
export const level1 = 50;
export const level2 = 100;
export const navBar = 150;
export const minimumMobileViewSize = 762;
